module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/auction-consultancy.c2354b2acb126be52ebf95a424fd3525.jpg";